import { Box } from "@mui/material";
import { ReactNode } from "react";
import { ContextLabel } from "../ContextLabel";
import { MessageAttachments } from "./MessageAttachments";
import { IChatMessageAttachment } from "./types";

interface IMessageBubbleProps {
    /** "end" hugs its own content and sits at the right (sent). "start" spans the full width and sits at the left (received). */
    align: "start" | "end";
    /** Off for the received message — same box (padding, radius), just no fill color. */
    withBackground?: boolean;
    /** Shows as a small tag above the bubble, when this message used a context. */
    contextLabel?: string;
    attachments?: IChatMessageAttachment[];
    children: ReactNode;
}

/** The box around a message's own text — one shared shape, parameterized for the sent vs received variations. */
const MessageBubble = ({ align, withBackground = true, contextLabel, attachments, children }: IMessageBubbleProps) => (
    <Box className={`chat-bubble-stack chat-bubble-stack--${align}`}>
        {attachments?.length ? <MessageAttachments attachments={attachments} /> : null}
        <Box className="chat-bubble-group">
            {contextLabel ? (
                <Box className="chat-context-header">
                    <ContextLabel context={contextLabel} compact />
                </Box>
            ) : null}
            <Box className={`chat-bubble${withBackground ? "" : " chat-bubble--plain"}`}>
                {children}
            </Box>
        </Box>
    </Box>
);

export { MessageBubble };
